var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "560"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_vm.gift ? _c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1"
  }, [_vm._v(" 캐시 선물 내역 "), _c('v-spacer'), _c('v-icon', {
    on: {
      "click": function click($event) {
        _vm.shows = false;
      }
    }
  }, [_vm._v("mdi-close")])], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "py-4"
  }, [_c('v-row', {
    staticClass: "ma-n2"
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-simple-table', {
    staticClass: "v-sheet--outlined",
    attrs: {
      "dense": ""
    }
  }, [_c('tbody', _vm._l(_vm.details, function (_ref2) {
    var term = _ref2.term,
        description = _ref2.description;
    return _c('tr', {
      key: term
    }, [_c('th', {
      staticClass: "text-caption grey lighten-4",
      attrs: {
        "width": "120"
      }
    }, [_vm._v(_vm._s(term))]), _c('td', {
      staticClass: "text-caption"
    }, [_vm._v(_vm._s(description))])]);
  }), 0)])], 1)], 1)], 1)], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }